import withTransport from '../HOCs/withTransport';
import WelcomeMessagesProviderComponent from './WelcomeMessagesProviderComponent';

export const WelcomeMessagesProvider = withTransport(WelcomeMessagesProviderComponent);
